import { AutogenModelCalculateBillingCharges, AutogenRowCalculateBillingCharges } from "./autogen/AutogenModelCalculateBillingCharges";

export class ModelCalculateBillingCharges extends AutogenModelCalculateBillingCharges<RowCalculateBillingCharges> {
	constructor() {
		super(RowCalculateBillingCharges);
	}
}

export class RowCalculateBillingCharges extends AutogenRowCalculateBillingCharges {
}